import { notification } from 'antd';
import t from '../config/locales';
import { DEFAULT_HUMAN_MESSAGE } from '../lib/errors/base-error';
import { isRejectedPromiseType } from './ducks/helpers/types';

const DEFAULT_MESSAGE = 'An error occurred';

const INFO_ERROR_CODES = [
  'TRIGGER_INFO',
];

const WARNING_ERROR_CODES = [
  'TRIGGER_WARNING',
];

const STATUS_CODE_NOTIFICATION = {
  401: {
    message: t('apiErrors.unauthorized.message'),
    description: t('apiErrors.unauthorized.description'),
  },
  403: {
    message: t('apiErrors.forbidden.message'),
    description: t('apiErrors.forbidden.description'),
  },
  404: {
    message: t('apiErrors.notFound.message'),
    description: t('apiErrors.notFound.description'),
  },
  500: {
    message: t('apiErrors.serverError.message'),
    description: t('apiErrors.serverError.description'),
  },
};

// eslint-disable-next-line no-unused-vars
export default function errorNotificationMiddleware(store) {
  return next => (action) => {
    const {
      error, payload, type, meta = {},
    } = action;
    if (!error || !isRejectedPromiseType(type)) return next(action);

    const { code, statusCode } = payload;

    const statusCodeNotification = STATUS_CODE_NOTIFICATION[statusCode] || {};
    const message = meta.errorMessage || statusCodeNotification.message || DEFAULT_MESSAGE;
    const apiError = payload.getHumanMessage && payload.getHumanMessage();
    const description = apiError !== DEFAULT_HUMAN_MESSAGE
      ? apiError
      : meta.errorDescription || statusCodeNotification.description || DEFAULT_HUMAN_MESSAGE;

    const notificationContent = { message, description };
    if (INFO_ERROR_CODES.indexOf(code) >= 0) notification.info(notificationContent);
    else if (WARNING_ERROR_CODES.indexOf(code) >= 0) notification.warning(notificationContent);
    else notification.error(notificationContent);

    return next(action);
  };
}
